module.exports = __webpack_public_path__ + "static/media/residences.9d99178f.jpg";